export class MedicoFilialPk {

    idMedico: number = 0;

    idFilial: number = 0;

    constructor() {
    }
}
